<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit pathUrl="/huangjiangyangdujun" />
    <Tit/>
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <div class="left_left1 flex_column">
          <div class="left_top flex_column">
            <div class="title"><span class="txt1">全国红薯产业现状</span></div>
            <div class="left_top_info">
              <div class="left_top_info_item flex_column" v-for="(item,index) in state.left_l_data1" :key="index">
                <div class="left_item_top">
                  <img :src="item.icon"/>
                  <div class="left_item_top_r flex_column"><span>{{item.txt1}}</span><span>{{item.txt2}}</span></div>
                </div>
                <div class="left_item_bottom">
                  <div class="item_item" v-for="(item0,index0) in item.list" :key="index0">
                    <span>{{item0.name}}</span><span>{{item0.value}}{{item0.unit}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="left_center flex_column">
            <div class="title1">全国红薯主要品种分布</div>
            <div class="left_center_info">
              <div class="left_center_item"><LeftPie :listData="state.left_l_data2[0]" /></div>
              <div class="left_center_item"><LeftPie :listData="state.left_l_data2[1]" /></div>
            </div>
          </div>
          <div class="left_down flex_column">
            <div class="title">
              <span class="txt1">全国红薯后市行情预测</span>
            </div>
            <div class="left_down_info">
              <div class="left_down_item"><LeftPie2/></div>
              <div class="left_down_item"><LeftPie3/></div>
              <div class="left_down_item"><LeftPie4/></div>
            </div>
          </div>
        </div>
        <div class="left_left2 flex_column">
          <div class="left_left2_box1 flex_column">
            <div class="title"><span class="txt1">近五年全国商薯电商批发价</span></div>
            <div class="ggtxt"><LeftLine :listData ="state.leftData4"/></div>
          </div>
          <div class="left_left2_box2 flex_column">
            <div class="title"><span class="txt1">全国红薯粉丝、粉条电商批发均价</span></div>
            <div class="ggtxt"><LeftLine2 :listData ="state.leftData5" :listData1 ="state.leftData3"/></div>
          </div>
        </div>
      </div>

      <!-- 中 -->
      <div class="middle flex_column">
        <div class="title"><span class="txt1">上蔡县红薯产业现状</span></div>
        <div class="middleBox1">
          <div class="middleBox1_l">
            <div class="middleBox1_l_item" v-for="(item,index) in state.centerData" :key="index">
              <div class="middleBox1_l_item_l">
                <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zy.png" />
                <span>{{item.name}}</span>
              </div>
              <div class="middleBox1_l_item_r">{{item.value}}{{item.unit}}</div>
            </div>
          </div>
          <div class="middleBox1_r">
            <div class="middleBox1_r_video"><img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/67tool/hongshu.jpg" /> </div>
            <h6>国家地理标志农产品“崇礼红薯”</h6>
          </div>
        </div>
        <div class="middleBox2">
          <div class="middleBox2_l">
            <div class="middleBox2_l_t">
              <div class="imgBox"><img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/67tool/caipanzi.png" /><img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/67tool/zhuangyuan.png" /></div>
              <div class="videoBox"><img src="../assets/img/sanchan1/img1.jpg" /> </div>
            </div>
<!--            <div class="middleBox2_l_b"><span v-for="(item,index) in state.centerData1" :key="index"><span v-html="item"></span></span></div>-->
          </div>
          <div class="middleBox2_r"><dv-scroll-board :config="state.config"  style="width: 100%; height: 100%"   /></div>
        </div>
      </div>
      <!-- 右 -->
      <div class="right flex_column" >
<!--        <RightBar />-->
        <div class="title"><span class="txt1">未来三年红薯产业发展计划</span></div>
        <div class="rightBoxInfo">
          <BoxItem title="电商销售额" title1="直播间">
            <template v-slot:left><RightBar :listData="state.rightData1" /></template>
            <template v-slot:right>
              <div class="videoBox"><vue3VideoPlay  id="video" ref="videoRef" width="100%" height="100%" title="视频监控" :src="state.options1.src" :type="state.options1.type" :autoPlay="false" :muted="true" :control="false" @loadedmetadata="onLoadedMetadata" /></div>
            </template>
          </BoxItem>
          <BoxItem title="加工业产业值" :title1="state.optionsArr[0].name">
            <template v-slot:left><RightBar :listData="state.rightData2" /></template>
            <template v-slot:right >
              <div class="img" @click="videoPop(0)">><img :src="state.optionsArr[0].img" /></div>
<!--              <iframe :src="state.options2.src + state.AccessToken" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>-->
            </template>
          </BoxItem>
          <BoxItem title="种植面积" :title1="state.optionsArr[1].name">
            <template v-slot:left><RightBar :listData="state.rightData3" /></template>
            <template v-slot:right>
              <div class="img" @click="videoPop(1)"><img :src="state.optionsArr[1].img" /></div>
            </template>
          </BoxItem>
          <BoxItem title="育苗规模" :title1="state.optionsArr[2].name">
            <template v-slot:left><RightBar :listData="state.rightData4" /></template>
            <template v-slot:right>
              <div class="img" @click="videoPop(2)"><img :src="state.optionsArr[2].img" /></div>
            </template>
          </BoxItem>
        </div>

      </div>
    </div>
  </div>
<!--  <div class="footer">本产品由来村网提供技术支持</div>-->
  <popBg v-if="state.popShow" :title="state.optionsArr[state.optionsArrIndex].name" :popShow="state.popShow" @hiddlen="popHiddlen"
         :code="state.optionsArr[state.optionsArrIndex].code">
    <div style=" width: 100%;height: 100%" v-if="state.AccessToken!=''">
      <iframe :src="state.optionsArr[state.optionsArrIndex].options.src + state.AccessToken" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
    </div>
  </popBg>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit1.vue";
import LeftPie from "@/components/hongshu1/LeftPie.vue"
import LeftLine from "@/components/hongshu1/left_line.vue"
import LeftLine2 from "@/components/hongshu1/left_line2.vue"
import BoxItem from "@/components/hongshu1/Box_item.vue"
import RightBar from "@/components/hongshu1/right_bar.vue"
import LeftPie2 from "@/components/hongshu1/leftPie2.vue"
import LeftPie3 from "@/components/hongshu1/leftPie3.vue"
import LeftPie4 from "@/components/hongshu1/leftPie4.vue"
import popBg from "@/components/popBg.vue"

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";
import Tit from "@/components/Tit.vue";

// const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const state = reactive({
  left_l_data1:[
    {txt1:"全国红薯",txt2:"",list:[{name:"总产量",value:1,unit:"亿吨"},{name:"占世界的",value:80,unit:"%"}],icon:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/zz.png"},
    {txt1:"河南红薯",txt2:"",list:[{name:"总产量",value:3000,unit:"万吨"},{name:"占全国的",value:30,unit:"%"}],icon:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/cl(1).png"}
  ],
  left_l_data2:[
    {
      name:"售卖",
      list:[
        {value: 23.8, name: "烟薯", },
        {value: 22.6, name: "西瓜红", },
        {value: 12, name: "蜜薯", },
        {value: 9.6, name: "龙薯", },
        {value: 5.7, name: "商薯", },
        {value: 26.3, name: "其他", },
      ]
    },
    {
      name:"采购",
      list:[
        {value: 27.4, name: "西瓜红", },
        {value: 26.8, name: "烟薯", },
        {value: 8.9, name: "蜜薯", },
        {value: 7.7, name: "龙薯", },
        {value: 5.1, name: "商薯", },
        {value: 24.1, name: "其他", },
      ]
    },
  ],
  leftData3:{
    color:["#FFD15C","rgba(255, 209 ,92,0)","rgba(255, 209 ,92,0)","rgba(255, 209 ,92,.3)"],
    time:["2020","2021","2022","2023","2024","2025"],
    data:["7.2","6.18","5.95","6.41","6.73","7.13"]
  },
  leftData4:{
    color:["#0783FA","rgba(7, 131 ,250,0)","rgba(7, 131 ,250,0)","rgba(7, 131 ,250,.3)"],
    time:["2020","2021","2022","2023","2024","2025"],
    data:["0.76","0.73","0.74","0.79","0.82","0.56"]
  },
  leftData5:{
    color:["#1FFFF7","rgba(31, 255 ,247,0)","rgba(31, 255 ,247,0)","rgba(31, 255 ,247,.3)"],
    time:["2020","2021","2022","2023","2024","2025"],
    data:["7.41","6.33","6","5.97","7.37","7.41"]
  },
  centerData:[
    {name:"种植历史：",value:"400",unit:"年"},
    {name:"主要种植品种：",value:"商薯19",unit:""},
    {name:"种植面积：",value:"40000",unit:"亩"},
    {name:"总产量：",value:"12.7",unit:"万吨"},
    {name:"年产红薯粉丝粉条：",value:"2.56",unit:"万吨"}
  ],
  centerData1:["XXX亩","发展红薯种植：4万亩","带动红薯淀粉加工</br>带动红薯粉丝粉条加工"],
  config: {
    header: ['时间', 'GMV', '流量', '订单量', '转化率'],
    data: [
      ['2023-03-25', '<span style="color:#8FBDDC;">1.96W</span>', "4.5W", "659", "8%"],
      ['3-24', '<span style="color:#8FBDDC;">1.86W</span>', "4.2W", "586", "7%"],
      ['3-23', '<span style="color:#8FBDDC;">2.06W</span>', "5.2W", "686", "10%"],
      ['3-22', '<span style="color:#8FBDDC;">2.26W</span>', "5.3W", "700", "11.2%"],
      ['3-21', '<span style="color:#8FBDDC;">1.94W</span>', "4.3W", "627", "9.6%"],
      ['3-20', '<span style="color:#8FBDDC;">2.26W</span>', "5.6W", "700", "8.6%"],
    ],
    oddRowBGC:"#041B39",
    evenRowBGC:"#041B39",
    headerHeight:"87",
    headerBGC:"#1B4764",
    align:["center","center","center","center","center"],
    rowNum:4
  },
  rightData1: {name:'电商销售额',unit:"万元",xValue:["2026", "2027","2028"],yValue: [1500, 2000, 2500],colorList: ["#1496FA","#0D2341","rgba(20, 150, 252, 1)"]},
  rightData2: {name:'加工业产业值',unit:"万元",xValue:["2026", "2027","2028"],yValue: [2000, 2500, 3000],colorList: ["#1496FA","#0D2341","rgba(20, 150, 252, 1)"]},
  rightData3: {name:'种植面积',unit:"亩",xValue:["2026", "2027","2028"],yValue: [50000, 60000, 80000],colorList: ["#F8CC59","rgba(248,204,89,.1)","#EBC461"]},
  rightData4: {name:'育苗数据',unit:"万株",xValue:[ "2026", "2027","2028"],yValue: [17500, 21000, 28000],colorList: ["#F8CC59","rgba(248,204,89,.1)","#EBC461"]},
  options1: {
    src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sgsp/hs02.mp4", //视频源
    type: "video/mp4", //视频类型
  },
  optionsArr:[
    {
      name:"加工车间",
      img:require('../assets/img/sanchan1/video2.jpg'),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2501929/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"FB2501929"
    },
    {
      name:"种植基地",
      img:require('../assets/img/sanchan1/video4.jpg'),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB1423291/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"FB1423291"
    },
    {
      name:"育苗基地",
      img:require('../assets/img/sanchan1/video3.jpg'),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2455304/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"FA2455304"
    },


  ],
  AccessToken:"",
  optionsArrIndex:0,
  popShow:false
});
function popHiddlen() {
  state.popShow = false;
}
function videoPop(index){
  console.log(index)
  state.popShow = true
  state.optionsArrIndex = index
}
function getPreviousDates(days) {
  let today = new Date();
  let previousDates = [];

  for (let i = 0; i < days; i++) {
    let date = new Date(today);
    date.setDate((today.getDate()-1) - i);
    console.log(date)
    // let month = specificDate.getMonth();
    let item = (date.getMonth()+1) + '-' +date.getDate();
    previousDates.push(item)
    // previousDates.push(date.toISOString().split('T')[0]);
  }

  return previousDates;
}

onMounted(() => {
  state.AccessToken = localStorage.getItem('AccessToken')
  let dates = getPreviousDates(6); // 获取今日之前的5个日期
  let configData = state.config.data
  for (var i = 0; i < configData.length; i++){
    state.config.data[i][0] = dates[i]
  }
});

onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 30px;
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 10000;
  font-weight: bold;
}

body {
  background-size: cover;
  line-height: 1.15;
}

.mainBox {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100%;

  .content {
    top: 220px;
    left: 0;
    width: 100%;
    position: absolute;
    height: calc(100% - 310px);
    flex-flow: row;
    display: flex;
    //公共的向下布局
    .flex_column {
      display: flex;
      flex-direction: column;
    }
    //公共标题
    .title {
      width: 100%;
      height: 60px;
      padding-left: 50px;
      box-sizing: border-box;
      line-height: 60px;
      color: #fff;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/dbt.png")
        no-repeat;
      display: flex;
      span {
        display: block;
      }
      .txt1 {
        font-size: 30px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        padding: 0 10px;
      }
      .txt2 {
        color: #0287ba;
        margin-left: 20px;
        font-size: 22px;
        font-family: Arial, Helvetica, sans-serif;
      }
    }
    .title1{
      width: 100%;
      height: 40px;
      font-size: 30px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/hongshuhuang/mj.png") no-repeat left bottom;
      color: #E0EFFF;
      text-align: left;
    }
    //公共布局
    .ggtxt {
      width: 100%;
      flex: 1;
    }

    .left {
      width: 2100px;
      height: 100%;
      margin-left: 100px;
      padding-top: 10px;
      //border: 1px solid #fff;
      display: flex;

      .left_left1 {
        flex: 1;
        height: 100%;
        .left_top {
          width: 100%;
          height: 300px;
          .left_top_info{
            width: 100%;
            flex: 1;
            display: flex;
            .left_top_info_item{
              width: 50%;
              height: 100%;
              padding-left: 70px;
              justify-content: center;
              .left_item_top{
                height:95px ;
                display: flex;
                align-items:center;
                img{
                  width: 95px;
                  height: 93px;
                  margin-right: 20px;
                }
                .left_item_top_r{
                  span{
                    display: block;
                    text-align: left;
                  }
                  span:first-child{color: #fff;font-size:36px; }
                  span:last-child{color: #FAB943;font-size:32px }
                }
              }
              .left_item_bottom{
                display: flex;
                font-size: 24px;
                margin-top: 20px;
                .item_item{
                  margin-right: 20px;
                  display: flex;
                  span{display: block;color: #fff;margin-right: 12px}
                  span:last-child{
                    color: #FAB943;
                  }

                }
              }
            }
            .left_top_info_item:nth-child(2){
              .left_item_top{
                span:last-child{color: #02D88C;font-size:32px }
              }
              .left_item_bottom{
                .item_item{
                  span:last-child{
                    color: #02D88C;
                  }
                }
              }
            }
          }
        }
        .left_center{
          flex: 1;
          padding-left: 70px;
          .left_center_info{
            flex: 1;
            width: 100%;
            display: flex;
            .left_center_item{
              flex: 1;
              height: 100%;
              //border: 1px solid;
              //transform: scale(.8);
            }
          }
        }
        .left_down {
          width: 100%;
          height: 460px;
          .left_down_info{
            width: 100%;
            flex: 1;
            display: flex;
            padding-top: 50px;
            .left_down_item{
              flex: 1;
              height: 100%;
            }
          }
        }
      }
      .left_left2 {
        flex: 1;
        height: 100%;
        .left_left2_box1{
          width: 100%;
          flex: 1;
          padding-bottom: 30px;
        }
        .left_left2_box2{
          width: 100%;
          height: 511px;

        }
      }
    }
    .middle {
      flex: 1;
      height: 100%;
      padding: 50px 100px 0;
      //border: 1px solid;
      .middleBox1{
        height: 633px;
        display: flex;
        padding-top: 30px;
        .middleBox1_l{
          flex: 1;
          height: 100%;
          padding-right: 50px;
          display: flex;
          flex-direction: column;
          .middleBox1_l_item{
            width: 100%;
            flex: 1;
            background: linear-gradient( to right, rgba(4,53,99,.5), rgba(4,53,99,0.1));
            margin-bottom: 30px;
            padding: 0 100px 0 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .middleBox1_l_item_l{
              font-size: 30px;
              display: flex;
              align-items: center;
              span{display: block;margin-left: 33px;color: #fff}
            }
            .middleBox1_l_item_r{
              font-size: 50px;
              color: #FFD15C;
            }
          }
        }
        .middleBox1_r{
          width:999px;
          height: 100%;
          .middleBox1_r_video{
            width: 100%;
            height: 518px;
            background: #fff;
            img{
              width: 100%;
              height: 100%;
            }
          }
          h6{
            height: 85px;
            line-height: 85px;
            background: #074870;
            color:#fff ;
            font-size: 30px;
          }
        }
      }
      .middleBox2{
        flex: 1;
        display: flex;
        padding:30px 0 0;
        .middleBox2_l{
          flex: 1;
          margin-right: 50px;
          position: relative;
          .middleBox2_l_t{
            width: 100%;
            height: 100%;
            background: url("../assets/img/hongshu/clpp.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .imgBox{
              flex: 1;
              display: flex;
              justify-content: space-between;
              img{
                width:260px;
                //height: 225px;
                background: #063E64;
                padding: 30px 20px;
              }
            }
            .videoBox{
              width: 380px;
              height: 259px;
              border: 1px solid;
              margin: 0 60px 0 60px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
          .middleBox2_l_b{
            width: 100%;
            height: 60px;
            color: #fff;
            display: flex;
            justify-content: space-between;
            font-size: 26px;
            margin-top:10px;
            span{
              width: 303px;
              display: block;
              //border: 1px solid;
              text-align: left;
              line-height: 40px;
            }
          }
        }
        .middleBox2_r{
          width:819px ;
          height: 95%;
          padding-top:50px;
          ::v-deep .dv-scroll-board .rows .row-item,
          ::v-deep .dv-scroll-board .header {
            font-size: 26px;
          }
          ::v-deep .dv-scroll-board .rows .row-item {
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
    .right {
      width: 2054px;
      height: 100%;
      padding-right: 100px;
      .rightBoxInfo{
        width: 100%;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        padding-top: 30px;
        justify-content: space-between;
        .img{
          width: 100%;
          height: 100%;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
